import React from 'react'
import { IGroup } from './types'
import { Card, H4 } from '@blueprintjs/core'
import { PrettyNumber } from '@ui'

interface IProps {
  summary: IGroup
}

export default function SummaryTable({ summary }: IProps) {
  const { name, columns, columnTypes, values } = summary
  const isNumberColumn = (cType: string) => ['int', 'decimal', 'percent'].includes(cType)

  return (
    <div
      style={{
        height: '100%',
        width: '100%',
        marginBottom: 24,
        overflowX: 'auto',
      }}>
      <Card style={{ width: 240 + 100 * (columns.length - 1) }}>
        <H4>{name}</H4>
        <table className="table no-width">
          <thead>
            <tr>
              {columns.map((c, i) => (
                <th
                  style={{
                    textAlign: isNumberColumn(columnTypes[i]) ? 'right' : undefined,
                    width: i === 0 ? 200 : 75,
                  }}
                  key={c}>
                  {c}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {values.map((row, i) => (
              <tr key={i}>
                {row.map((v, j) => (
                  <td
                    key={j}
                    style={{
                      textAlign: isNumberColumn(columnTypes[j]) ? 'right' : undefined,
                      fontWeight: i === values.length - 1 ? 'bolder' : 'normal',
                      width: i === 0 ? 100 : 40,
                    }}>
                    {isNumberColumn(columnTypes[j]) ? <PrettyNumber value={v} /> : v}
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </Card>
    </div>
  )
}
